<script setup lang="ts">
// inbox-207 placeholder — workspace switcher (полная реализация в @vps-backend's inbox-207).
// Пока пустой компонент чтобы build проходил.
</script>

<template>
  <div class="workspace-switcher" aria-hidden="true"></div>
</template>

<style scoped>
.workspace-switcher {
  display: none;
}
</style>
